import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import {REACT_APP_NODE_ENV} from "./constants/env";
import './lang';
import {ScrollProvider} from "./components/Scroll/Scroll";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import BackTop from "./pages/components/BackTop/BackTop";
import LanguageButton from "./pages/components/Lan/LanguageButton";
import HomePage from "./pages/Home/HomePage";
import LoginPage from "./pages/Login/LoginPage";
import RegisterPage from "./pages/Register/RegisterPage";
import Platform from "./pages/Platform/Platform";
import NotFoundPage from "./pages/404/NotFoundPage";
import {getUserByToken} from "./store/slices/userSlice";
import FullLoading from "./components/LoadingComponents/FullLoading";
import MonitoringPage from "./pages/Monitoring/MonitoringPage";
import DataPage from "./pages/Data/DataPage";
import ArgoGisPage from "./pages/ArgoGis/ArgoGisPage";
import AboutPage from "./pages/About/AboutPage";
import ListArticles from "./pages/About/ListArticles";
import DashboardPage from "./pages/Dashboard/DashboardPage";

if (REACT_APP_NODE_ENV === 'production') {
    disableReactDevTools();
}

function App() {
    // const {user, isLoading} = useSelector(state => state.user);
    // const dispatch = useDispatch();
    //
    // useEffect(() => {
    //     dispatch(getUserByToken());
    // }, []);

    // if (isLoading) {
    //   return <FullLoading/>;
    // }

    return (
        <ScrollProvider>
            <BackTop/>
            <LanguageButton/>
            <Router>
                <Routes>
                    <Route path='/' element={<HomePage/>}/>
                    <Route path='/monitoring' element={<MonitoringPage/>}/>
                    <Route path='/about' element={<AboutPage/>}/>
                    <Route path='/list-articles' element={<ListArticles/>}/>
                    <Route path='/monitoring/data' element={<DataPage/>}/>
                    <Route path='/argo-gis' element={<ArgoGisPage/>}/>
                    <Route path='/dashboard' element={<DashboardPage/>}/>
                    {/*<Route path='/login' element={user === null ? <LoginPage/> : <Navigate to="/p/home" replace />}/>*/}
                    {/*<Route path='/register' element={user === null ? <RegisterPage/> : <Navigate to="/p/home" replace />}/>*/}
                    {/*<Route path='/p/*' element={user !== null ? <Platform/> : <Navigate to="/login" replace />}/>*/}
                    <Route path='*' element={<NotFoundPage/>}/>
                </Routes>
            </Router>
        </ScrollProvider>
    );
}

export default App;
